var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.user && _vm.userOnboard
        ? _c("div", { staticClass: "p-2" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-8 white-back" }, [
                _vm.state === "welcome"
                  ? _c("div", [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.userOnboard.welcomeBody),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-100 d-flex justify-content-center my-5",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-dark rounded-pill btn-lg",
                              attrs: { type: "button" },
                              on: { click: _vm.onGotoCourse },
                            },
                            [_vm._v("次へ")]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.state === "course"
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "cursor-pointer font-bold",
                          on: { click: _vm.onGotoWelcome },
                        },
                        [_vm._v("＜ 戻る")]
                      ),
                      _vm._v(" "),
                      _c("h3", { staticClass: "my-2" }, [
                        _vm._v(
                          "\n            コースを選択しましょう\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        _vm._l(_vm.userOnboard.courses, function (item, index) {
                          return _c(
                            "div",
                            {
                              staticClass:
                                "form-check d-flex align-items-center",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: item.selected,
                                    expression: "item.selected",
                                  },
                                ],
                                staticClass: "form-check-input flex-shrink-0",
                                style: {
                                  width: "30px",
                                  height: "30px",
                                },
                                attrs: {
                                  type: "checkbox",
                                  id: "checkbox_id_" + item.id,
                                },
                                domProps: {
                                  value: item.id,
                                  checked: Array.isArray(item.selected)
                                    ? _vm._i(item.selected, item.id) > -1
                                    : item.selected,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = item.selected,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = item.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            item,
                                            "selected",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            item,
                                            "selected",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(item, "selected", $$c)
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label d-flex p-1",
                                  attrs: { for: "checkbox_id_" + item.id },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-1 flex-shrink-0" },
                                    [
                                      item.image
                                        ? _c("v-img", {
                                            attrs: {
                                              "min-height": "100",
                                              "min-width": "100",
                                              "max-height": "100",
                                              "max-width": "100",
                                              src: item.image.url,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", [_vm._v(_vm._s(item.name))]),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-100 d-flex justify-content-center my-5",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-dark rounded-pill btn-lg",
                              attrs: { type: "button" },
                              on: { click: _vm.onGotoForm },
                            },
                            [_vm._v("次へ")]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.state === "contact_form"
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "cursor-pointer font-bold",
                          on: { click: _vm.onGotoCourse },
                        },
                        [_vm._v("＜ 戻る")]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "text-center",
                        domProps: {
                          innerHTML: _vm._s(_vm.userOnboard.bodyHtml),
                        },
                      }),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "portal",
        { attrs: { to: "header-left-drawer" } },
        [
          _c(
            "v-navigation-drawer",
            {
              attrs: { dark: "", fixed: "", app: "" },
              model: {
                value: _vm.drawer,
                callback: function ($$v) {
                  _vm.drawer = $$v
                },
                expression: "drawer",
              },
            },
            [
              _c(
                "v-toolbar",
                { staticClass: "transparent" },
                [
                  _c(
                    "v-list",
                    { staticClass: "p-0" },
                    [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "home-header",
                          nativeOn: {
                            click: function ($event) {
                              return _vm.goToHome.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("v-list-item-avatar", [
                            _vm.schoolSetting && _vm.schoolSetting.imageUrl
                              ? _c("img", {
                                  attrs: { src: _vm.schoolSetting.imageUrl },
                                })
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _vm.schoolSetting && _vm.schoolSetting.name
                                ? _c("v-list-item-title", [
                                    _vm._v(_vm._s(_vm.schoolSetting.name)),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list",
                {
                  staticClass: "pt-0 custom-links-v-list",
                  attrs: { dense: "" },
                },
                [
                  _c(
                    "v-list-item",
                    { attrs: { to: "/classroom/on-boarding" } },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("home")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n              オンボーディング\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }